import React from 'react'
import PropTypes from 'prop-types'
import cssModules from 'react-css-modules'
import {
  CaptionText,
  BodyText,
  Button,
  Dialog,
  HeadingText,
  Modal,
} from '@paypalcorp/pp-react'
import styles from './crowdfunding_cover.less'
import CrowdFundingCoverImage from 'components/crowdfunding_cover_image'
import CrowdFundingPreview from 'components/pages/crowdfunding/crowdfunding_preview'
import {
  trackClick,
  trackEventNameClick,
  trackImpression,
} from 'lib/fpti_analytics'
import TipBox from 'components/common/tip_box'

import { getI18n } from 'client/i18n'

export const I18N_CONTEXT = 'components/pages/crowdfunding/crowdfunding_cover'
const i18n = getI18n(I18N_CONTEXT)

class CrowdFundingCover extends React.Component {
  static propTypes = {
    anyInactiveFieldsTouchedWithError: PropTypes.bool.isRequired,
    backgroundImage: PropTypes.string,
    backgroundPan: PropTypes.number,
    charity: PropTypes.object,
    countryCode: PropTypes.string,
    fields: PropTypes.object.isRequired,
    gradientColor: PropTypes.string,
    handleSubmit: PropTypes.func.isRequired,
    isAndroid: PropTypes.bool,
    onChangeCover: PropTypes.func,
    setData: PropTypes.func,
    shouldAutoFocus: PropTypes.bool,
    submit: PropTypes.func,
    termsAndConditionLink: PropTypes.string,
  }

  constructor(props) {
    super(props)
    this.coverImage = React.createRef()
  }

  state = {
    isOpen: false,
    isPhotoModal: false,
  }

  getFPTITags = () => {
    return {
      charity_name: this.props.charity && this.props.charity.name,
      npid: this.props.charity && this.props.charity.nonprofit_id,
      flow: this.props.charity
        ? 'GENEROSITY_NETWORK_CHARITIES'
        : 'GENEROSITY_NETWORK',
    }
  }

  setData() {
    this.props.setData({
      background_image: this.props.fields.backgroundImage.value,
      background_image_filename: this.props.fields.backgroundImageFilename
        .value,
      background_pan: this.props.fields.backgroundPan.value,
    })
  }
  handleModalClick = e => {
    e.preventDefault()
    this.setData()
    this.setState({ isOpen: true })
    trackClick({
      clickName: 'dw_giving_fundraiser_add_photo_preview_pressed',
      data: {
        event_name: 'dw_giving_fundraiser_add_photo_preview_pressed',
        photo_uploaded_flag: this.props.fields.backgroundImage.value ? 1 : 0,
        ...this.getFPTITags(),
      },
    })
    trackImpression({
      pageName: 'Preview',
      event_name: 'dw_giving_fundraiser_preview_screen_shown',
      ...this.getFPTITags(),
    })
  }

  handleModalClose = () => {
    this.setState({ isOpen: false })
    const { charity } = this.props
    const flow = charity ? 'GENEROSITY_NETWORK_CHARITIES' : 'GENEROSITY_NETWORK'
    trackClick({
      clickName: 'dw_giving_fundraiser_preview_dismiss_pressed',
      data: {
        event_name: 'dw_giving_fundraiser_preview_dismiss_pressed',
        dismiss_method: 'close',
        flow: flow,
      },
    })
  }

  handleSubmit = e => {
    e.preventDefault()
    trackClick({
      clickName: 'dw_giving_fundraiser_add_photo_publish_pressed',
      data: {
        event_name: 'dw_giving_fundraiser_add_photo_publish_pressed',
        photo_uploaded_flag: this.props.fields.backgroundImage.value ? 1 : 0,
        ...this.getFPTITags(),
      },
    })
    if (this.props.fields.backgroundImage.value) {
      this.submitCoverPage()
    } else {
      trackImpression({
        pageName: 'no-photo-screen-shown',
        event_name: 'dw_giving_fundraiser_no_photo_screen_shown',
        ...this.getFPTITags(),
      })
      this.setState({ isPhotoModal: true })
    }
  }
  submitCoverPage = () => {
    if (this.state.isPhotoModal) {
      trackEventNameClick({
        event_name: 'dw_giving_fundraiser_no_photo_proceed_pressed',
        ...this.getFPTITags(),
      })
    }
    this.setData()
    return this.props.submit(
      `${GLOBAL_CONSTS.REQUEST_URI}/c/create-crowdfunding/publish`
    )
  }

  handlePhotoModalClose = e => {
    if (e) {
      trackEventNameClick({
        event_name: 'dw_giving_fundraiser_no_photo_dismiss_pressed',
        dismiss_method: 'close',
        ...this.getFPTITags(),
      })
    }
    this.setState({ isPhotoModal: false })
  }

  handleAddPhoto = () => {
    trackEventNameClick({
      event_name: 'dw_giving_fundraiser_no_photo_add_pressed',
      ...this.getFPTITags(),
    })
    this.coverImage.current.imageUploadClick()
    this.handlePhotoModalClose()
  }

  render() {
    const {
      anyInactiveFieldsTouchedWithError,
      charity,
      termsAndConditionLink,
    } = this.props

    return (
      <form>
        <HeadingText size="md" styleName="title">
          {i18n('title')}
        </HeadingText>
        <BodyText styleName="sub-title">{i18n('sub_title')}</BodyText>
        <div
          styleName="uploader"
          onClick={() =>
            trackEventNameClick({
              event_name: 'dw_giving_fundraiser_add_photo_upload_pressed',
              charity_name: charity && charity.name,
              npid: charity && charity.nonprofit_id,
            })
          }
        >
          <CrowdFundingCoverImage
            fields={this.props.fields}
            ref={this.coverImage}
          />
        </div>
        <TipBox text={i18n('tip_description')} />
        <CaptionText
          styleName="disclaimer"
          dangerouslySetInnerHTML={{
            __html: i18n('disclaimer', {
              tc_link: termsAndConditionLink,
            }),
          }}
        />
        <button
          onClick={this.handleSubmit}
          styleName="btn"
          className={`vx_btn vx_btn-primary vx_btn-block ${
            anyInactiveFieldsTouchedWithError ? 'vx_btn-disabled' : ''
          }`}
          disabled={anyInactiveFieldsTouchedWithError}
          data-nemo="agree-publish"
          type="button"
        >
          {i18n('publish')}
        </button>
        <button
          onClick={this.handleModalClick}
          styleName="btn"
          className={`vx_btn vx_btn-secondary vx_btn-block ${
            anyInactiveFieldsTouchedWithError ? 'vx_btn-disabled' : ''
          }`}
          disabled={anyInactiveFieldsTouchedWithError}
          data-nemo="preview-next"
          type="button"
        >
          {i18n('preview')}
        </button>
        <Modal
          isOpen={this.state.isOpen}
          onClose={this.handleModalClose}
          styleName="modal"
          action={
            <HeadingText size="md" styleName="modal_title">
              {i18n('preview')}
            </HeadingText>
          }
        >
          <CrowdFundingPreview />
        </Modal>
        <Dialog
          center
          isOpen={this.state.isPhotoModal}
          containerClassName={styles.container_class}
          onClose={this.handlePhotoModalClose}
          title={<HeadingText size="lg">{i18n('no_photo_title')}</HeadingText>}
        >
          <div styleName="no_photo_row">
            <BodyText>{i18n('no_photo_subtitle')}</BodyText>
          </div>
          <div styleName="button_offset">
            <Button styleName="no_photo-button" onClick={this.handleAddPhoto}>
              {i18n('add_photo')}
            </Button>
          </div>
          <div styleName="no_photo_row">
            <Button
              styleName="no_photo-button"
              onClick={this.submitCoverPage}
              secondary
              data-nemo="no-photo"
            >
              {i18n('continue')}
            </Button>
          </div>
        </Dialog>
      </form>
    )
  }
}

export default cssModules(CrowdFundingCover, styles)
